import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { FiatWalletTileComponent } from "./fiat-wallet-tile/fiatwallet-tile.component";
import { TradableAmountTileComponent } from "./tradable-amount-tile/tradable-amount-tile.component";
import { FiatAmountTileComponent } from "./fiat-amount-tile/fiat-amount-tile.component";
import { ProviderTileComponent } from "./provider-tile/provider-tile.component";
import { VoucherTileComponent } from "./voucher-tile/voucher-tile.component";

const components = [
	FiatWalletTileComponent,
	TradableAmountTileComponent,
	FiatAmountTileComponent,
	ProviderTileComponent,
	VoucherTileComponent
];

@NgModule({
	imports: [CoreModule],
	declarations: [...components],
	exports: [...components]
})
export class TilesModule {}
